<title>Autoverkoop Partner - Informatie bewerken</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>

        <h1 class="font-weight-light">Informatie bewerken</h1>

        @if (showThankYou == false && displayedFields.length > 0) {
          <div>
            <p>
              Bedankt voor het doorgeven van de extra informatie! Helaas zijn de
              documenten incompleet of slecht leesbaar. Let op dat je duidelijke
              foto's of scans maakt. Wil je ze opnieuw uploaden voor ons? Dan gaan
              wij er direct mee aan de slag!
            </p>
            <form [formGroup]="validationForm" class="needs-validation">
              @if (true) {
                <div>
                  @if (needToEdit('registrationcard_back') || needToEdit('registrationcard_front')) {
                    <div class="form-group"
                      >
                      <label><b>Kopie RDW kentekencard</b></label>
                      <div class="row">
                        <div class="form-group col">
                          <ngb-accordion #acc="ngbAccordion">
                            <ngb-panel title="Voorbeeld...">
                              <ng-template ngbPanelContent>
                                <p>Deze gegevens hebben wij nodig om je voertuig te kunnen verwerken.
                                  Zorg
                                ervoor dat de scans / foto's duidelijk leesbaar zijn.</p>
                                <img src="../../assets/images/kentekencard-voorkant.jpg"
                                  class="card-image img-fluid" alt="Kentekencard voorkant">
                                <img src="../../assets/images/kentekencard-achterkant.jpg"
                                  class="card-image img-fluid" alt="Kentekencard achterkant">
                              </ng-template>
                            </ngb-panel>
                          </ngb-accordion>
                        </div>
                      </div>
                      @if (uploadDocumentError != '') {
                        <div class="alert alert-danger" role="alert">
                          {{uploadDocumentError | json}}
                        </div>
                      }
                      <div class="row">
                        <div class="form-group col-md-8">
                          @if (documentUploading) {
                            <div class="progress">
                              <div class="progress-bar progress-bar-striped progress-bar-animated"
                                style="width: 100%">
                              Bezig met uploaden...</div>
                            </div>
                          }
                        </div>
                      </div>
                      @if (needToEdit('registrationcard_back') || needToEdit('registrationcard_front')) {
                        <div class="row"
                          >
                          @if (needToEdit('registrationcard_front')) {
                            <div class="form-group col-md-4">
                              <h4>Voorkant kentekencard</h4>
                              <div class="custom-file">
                                <input
                                  (change)="uploadValuationDocument('registrationcard_front', $event.target.files)"
                                  formControlName="licenseCardFront" type="file" class="custom-file-input"
                                  id="customFile"
                                  [ngClass]="{ 'is-invalid': submitted && f.licenseCardFront.errors }">
                                <label class="custom-file-label" for="customFile">Voorkant kentekencard</label>
                                @if (submitted && f.licenseCardFront.errors) {
                                  <div class="invalid-feedback">
                                    @if (f.licenseCardFront.errors.required) {
                                      <div> Upload een bestand
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                              @if (frontUploadOk) {
                                <div style="margin-top: 10px;" class="alert alert-success"
                                  role="alert">
                                  Bestand is opgeslagen
                                </div>
                              }
                            </div>
                          }
                          @if (needToEdit('registrationcard_back')) {
                            <div class="form-group col-md-4">
                              <h4>Achterkant kentekencard</h4>
                              <div class="custom-file">
                                <input
                                  (change)="uploadValuationDocument('registrationcard_back', $event.target.files)"
                                  formControlName="licenseCardBack" type="file" class="custom-file-input"
                                  id="customFile"
                                  [ngClass]="{ 'is-invalid': submitted && f.licenseCardBack.errors }">
                                <label class="custom-file-label" for="customFile">Achterkant kentekencard</label>
                                @if (submitted && f.licenseCardBack.errors) {
                                  <div class="invalid-feedback">
                                    @if (f.licenseCardBack.errors.required) {
                                      <div> Upload een bestand
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                              @if (backUploadOk) {
                                <div style="margin-top: 10px;" class="alert alert-success"
                                  role="alert">
                                  Bestand is opgeslagen
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <div class="row">
                    <div class="form-group col-md-4">
                      <button class="btn btn-primary" (click)="onSubmit()">Versturen</button>
                    </div>
                  </div>
                </div>
              }
            </form>
          </div>
        }

        @if (showThankYou == true) {
          <div>
            <div class="alert alert-success" role="alert">
              Bedankt! Je informatie is ontvangen.
            </div>
            <div class="form-group">
              <button class="btn btn-primary" (click)="close()">Sluiten</button>
            </div>
          </div>
        }

        <div style="height: 700px"></div>
      </div>
    </div>
  </div>